module.exports = __webpack_public_path__ + "static/img/logo_zhu82.11e7199.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_zhu82.png
// module id = Rm5/
// module chunks = 16